export default "__VITE_ASSET__KJgq9Sae__"